import { cn } from '@/lib/utils';
export function Separator({ text, className }: { text?: string; className?: string }) {
  if (text) return <div className={cn('flex items-center gap-4', className)}><div className="h-px flex-1 bg-slate-200"/><span className="text-xs text-slate-400">{text}</span><div className="h-px flex-1 bg-slate-200"/></div>;
  return <div className={cn('h-px w-full bg-slate-200', className)}/>;
}
